import Flickity from 'flickity'
import jQueryBridget from 'jquery-bridget'
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {Draggable} from 'gsap/Draggable'
import {InertiaPlugin} from 'gsap/InertiaPlugin'

// make Flickity a jQuery plugin
Flickity.setJQuery($)
jQueryBridget('flickity', Flickity, $)

gsap.registerPlugin(ScrollTrigger, Draggable, InertiaPlugin)

$('.media-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiper = new Swiper(this, {
    navigation: {
      nextEl: $container.find('.carousel-next')[0],
      prevEl: $container.find('.carousel-previous')[0],
    },
    loop: false,
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: $container.find('.carousel-pagination')[0],
      clickable: true,
    },
  })

  let slidersCount = swiper.slides.length;
  let $progressBar = $this.parents( '.carousel-container' ).find( '.progress-bar' );

  $progressBar.css( { 'width': 100 / slidersCount + '%' } );

  swiper.on( 'slideChange slideChangeTransitionEnd', function() {
    $progressBar.css( { 'left': (100 / slidersCount) * this.activeIndex + '%' } );

    let fancyboxImage = $this.find( '.swiper-slide' ).eq( swiper.realIndex ).attr( 'data-fancybox-image' );
    $this.parents( '.carousel-container' ).find( '.carousel-zoom' ).attr( 'href', fancyboxImage );
  } );
})

for ( const carouselContainer of document.querySelectorAll( '.gsap-carousel-container' ) ) {
  const grid = carouselContainer.querySelector( '.gsap-carousel-grid' )
  const imageCarousel = carouselContainer.querySelector( '.gsap-image-carousel' )
  const slides = imageCarousel.querySelectorAll( '.gsap-slide' )
  const dragProxy = imageCarousel.querySelector( '.gsap-drag-proxy' )
  const prevButtons = carouselContainer.querySelectorAll( '.gsap-carousel-prev' )
  const nextButtons = carouselContainer.querySelectorAll( '.gsap-carousel-next' )
  const progressBarPosition = carouselContainer.querySelector( '.gsap-carousel-progress-bar-position' )
  let slideChangeTween = null

  function getWrappedIndex(index, length) {
    return ((index % length) + length) % length
  }

  function getGridProperties() {
    const computedStyle = window.getComputedStyle( grid )
    return {
      width: parseFloat( computedStyle.getPropertyValue( 'width' ) ),
      paddingLeft: parseFloat( computedStyle.getPropertyValue( 'padding-left' ) ),
      paddingRight: parseFloat( computedStyle.getPropertyValue( 'padding-right' ) ),
      paddingX: parseFloat( computedStyle.getPropertyValue( 'padding-left' ) ) + parseFloat( computedStyle.getPropertyValue( 'padding-right' ) ),
      columnGap: parseFloat( computedStyle.getPropertyValue( 'column-gap' ) ),
      fr: parseFloat( computedStyle.getPropertyValue( 'grid-template-columns' ) )
    }
  }

  function isMobile(gridProperties = getGridProperties()) {
    return gridProperties.width / 2 < gridProperties.fr
  }

  function pixelsToViewWidth( pixels ) {
    return pixels * (1 / window.innerWidth) * 100
  }

  function pixelsToCarouselOffset(pixels) {
    const dragVelocity = (isMobile()) ? 0.15 : 0.3
    return pixelsToViewWidth(pixels) * dragVelocity
  }

  function changeSlide(direction) {
    draggable.tween?.pause()
    slideChangeTween?.pause()

    let start = draggable.x
    let end
    if (slideChangeTween) {
      end = slideChangeTween.vars.inertia.x.max
    } else if (draggable.tween) {
      end = draggable.tween.vars.inertia.x.end(draggable.x)
    } else {
      end = draggable.x
    }

    const mobile = isMobile()
    if (direction > 0) {
      end += window.innerWidth / (mobile ? 1.5 : 3)
    } else if (direction < 0) {
      end -= window.innerWidth / (mobile ? 1.5 : 3)
    }
    const obj = {
      x: start,
    }
    slideChangeTween = gsap.to(obj, {
      duration: 0.25,
      inertia: {
        x: {
          velocity: 1,
          min: end,
          max: end,
        },
      },
      onUpdate() {
        gsap.set(dragProxy, {x: obj.x})
        draggable.update()
        updateImageCarousel(pixelsToCarouselOffset(obj.x), direction)
      },
      onComplete() {
        slideChangeTween = null
      },
    })
  }

  for (const [index, slide] of slides.entries()) {
    slide.dataset.slideIndex = index
  }
  imageCarousel.style.width = `${slides.length * window.innerWidth}px`

  let oldMobile = isMobile()
  let oldWindowWidth = window.innerWidth
  window.addEventListener( 'resize', () => {
    const mobile = isMobile()
    let factor = 1
    if (oldMobile !== mobile) {
      factor = (oldMobile) ? 0.5 : 2
    }

    gsap.set( dragProxy, {x: (draggable.x * factor) / oldWindowWidth * window.innerWidth} )
    draggable.update()
    updateImageCarousel( pixelsToCarouselOffset( draggable.x ), 1 )

    oldMobile = isMobile()
    oldWindowWidth = window.innerWidth
  } )
  for ( const prevButton of prevButtons ) {
    prevButton.addEventListener( 'click', ( event ) => {
      event.preventDefault()
      console.log('Previous')
      changeSlide(1)
    })
  }
  for (const nextButton of nextButtons) {
    nextButton.addEventListener('click', (event) => {
      event.preventDefault()
      console.log('Next')
      changeSlide(-1)
    })
  }

  function updateImageCarousel( offsetInViewWidth, direction = 0 ) {
    const gridProperties = getGridProperties()
    const mobile = isMobile(gridProperties)
    let slideIndex = getWrappedIndex( slides.length - Math.round( offsetInViewWidth / 10 ), slides.length )
    // console.log( 'active slide', slideIndex )
    const fr = gridProperties.fr
    const gap = gridProperties.columnGap


    let largeSlide
    let mediumSlide
    let smallSlide
    if ( mobile ) {
      const slide = ( x = 20 ) => 0.9 * fr
      largeSlide = slide
      mediumSlide = slide
      smallSlide = slide
    } else {
      largeSlide = ( x = 0 ) => (fr + gap) * (-0.4 * x + 6)
      mediumSlide = ( x = 10 ) => (-gap / 5) * x + 2 * (fr + gap)
      smallSlide = ( x = 20 ) => 2 * fr
    }

    for ( const [index, slide] of slides.entries() ) {
      const x = Math.abs( Math.abs( ((offsetInViewWidth + index * 10)) - (slides.length * 10 / 2) ) % (slides.length * 10) - slides.length * 10 / 2 )
      slide.style.width = `${Math.max( largeSlide( x ), mediumSlide( x ), smallSlide( x ) )}px`
    }

    let imageCarouselOffset = (offsetInViewWidth - 5) % 10 / 10 * smallSlide() - smallSlide() / 2 - gap / 2 - ((offsetInViewWidth > 5) ? smallSlide() : 0)
    if ( mobile ) {
      imageCarouselOffset -= ((largeSlide() + 2 * mediumSlide() + 2 * smallSlide() + 3 * gap) - gridProperties.width) / 2 - 2 * gap
    } else {
      const normalizedX = Math.abs( offsetInViewWidth ) % 10
      const centerOffsetWhileDragging = ((normalizedX < 5) ? (normalizedX / 5) : (1 - ((normalizedX - 5) / 5))) * gap
      imageCarouselOffset -= ((largeSlide() + 2 * mediumSlide() + 2 * smallSlide() + 5 * gap) - gridProperties.width) / 2 - gap - centerOffsetWhileDragging
    }

    // console.log( (gridProperties.width - gridProperties.paddingLeft - gridProperties.paddingRight - 11* gridProperties.columnGap) / 11, gridProperties.fr )
    imageCarousel.style.transform = `translateX(calc(${imageCarouselOffset}px))`

    const leftSlideIndex = getWrappedIndex( slideIndex - 3, slides.length )
    // console.log( `slideIndex=${slideIndex}`, `leftSlideIndex=${leftSlideIndex}` )
    while (imageCarousel.querySelectorAll('.gsap-slide')[0].dataset.slideIndex != leftSlideIndex) {
      const upToDateImageCarousel = imageCarousel.querySelectorAll('.gsap-slide')
      if (direction < 0) {
        const appendSlide = upToDateImageCarousel[0]
        // console.log( 'append', appendSlide.dataset.slideIndex )
        imageCarousel.append(upToDateImageCarousel[0])
      } else {
        const prependSlide = upToDateImageCarousel[upToDateImageCarousel.length - 1]
        // console.log( 'prepend', prependSlide.dataset.slideIndex )
        imageCarousel.prepend(prependSlide)
      }
    }

    progressBarPosition.style.width = `${100 / slides.length}%`
    progressBarPosition.style.left = `${(100 * slideIndex) / slides.length}%`
  }

  const draggable = Draggable.create(dragProxy, {
    type: 'x',
    trigger: imageCarousel,
    inertia: true,
    snap: function (value) {
      const snap = window.innerWidth / (isMobile() ? 1.5 : 3)
      return Math.round(value / snap) * snap
    },
    onPress() {
      slideChangeTween?.pause()
      slideChangeTween = null
    },
    onDrag() {
      updateImageCarousel(pixelsToCarouselOffset(this.x), this.deltaX)
    },
    onThrowUpdate() {
      updateImageCarousel(pixelsToCarouselOffset(this.x), this.deltaX)
    },
    onThrowComplete() {
      updateImageCarousel(pixelsToCarouselOffset(this.x), this.deltaX)
    },
  })[0]

  updateImageCarousel(0, 0)
}

$('.flickity-image-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  $this.flickity({
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    cellAlign: 'center',
    selectedAttraction: 0.015,
    friction: 0.25,
  })

  // Bind Custom Navigation Buttons
  $container.find('.carousel-next').on('click', function () {
    $this.flickity('next')
  })

  $container.find('.carousel-previous').on('click', function () {
    $this.flickity('previous')
  })
})
